import { Button } from "@/components/ui/button";
import {
  Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle,
} from "@/components/ui/dialog";
import { AlertTriangle, CheckCircle2, Copy, MessageCircle } from "lucide-react";
import { toast } from "sonner";

export function inviteText(name, link, shopName) {
  return `Olá, ${name || ""}! ${shopName ? `${shopName} criou` : "Criamos"} sua conta no AutoOficina.\n\nPara entrar, crie sua senha neste link (vale 72 horas, uso único):\n${link}`;
}

export function waHref(phone, text) {
  const digits = (phone || "").replace(/\D/g, "");
  return digits ? `https://wa.me/${digits.length <= 11 ? `55${digits}` : digits}?text=${encodeURIComponent(text)}` : `https://wa.me/?text=${encodeURIComponent(text)}`;
}

export function InviteActions({ result, shopName, testid = "welcome" }) {
  const text = inviteText(result.name, result.invite_link, shopName);
  const copy = async () => {
    try { await navigator.clipboard.writeText(result.invite_link); toast.success("Link copiado"); }
    catch { toast.error("Não foi possível copiar"); }
  };
  return (
    <>
      <div className="rounded-xl border border-zinc-800 bg-zinc-900 p-4 space-y-1 text-sm">
        <div><span className="text-zinc-500">Login: </span><span data-testid={`${testid}-login-email`} className="font-semibold break-all">{result.email}</span></div>
        <div><span className="text-zinc-500">Link para criar a senha: </span><span data-testid={`${testid}-invite-link`} className="break-all text-zinc-300">{result.invite_link}</span></div>
        <div className="text-[11px] text-zinc-500">Vale 72 horas e pode ser usado uma vez. Gerar um novo invalida o anterior.</div>
      </div>
      <div className="grid grid-cols-2 gap-3">
        <Button data-testid={`${testid}-copy-btn`} type="button" variant="outline" onClick={copy}
          className="h-11 bg-zinc-900 border-zinc-800 text-zinc-200 hover:bg-zinc-800 font-bold uppercase">
          <Copy className="h-4 w-4 mr-2" /> Copiar link
        </Button>
        <a data-testid={`${testid}-whatsapp-btn`} href={waHref(result.phone, text)} target="_blank" rel="noopener noreferrer"
          className="inline-flex items-center justify-center h-11 rounded-md bg-emerald-600 hover:bg-emerald-500 text-white text-sm font-bold uppercase">
          <MessageCircle className="h-4 w-4 mr-2" /> WhatsApp
        </a>
      </div>
    </>
  );
}

export function WelcomeResultDialog({ result, onClose, shopName, title = "Cliente criado" }) {
  if (!result) return null;
  return (
    <Dialog open onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent data-testid="welcome-result-dialog" className="bg-zinc-950 border border-zinc-800 text-zinc-100 max-w-md">
        <DialogHeader>
          <DialogTitle className="font-display uppercase flex items-center gap-2">
            {result.email_sent
              ? (<><CheckCircle2 className="h-5 w-5 text-green-neon" /> {title}</>)
              : (<><AlertTriangle className="h-5 w-5 text-amber-brand" /> E-mail não enviado</>)}
          </DialogTitle>
          <DialogDescription data-testid="welcome-result-message" className={result.email_sent ? "text-zinc-400" : "text-amber-200"}>
            {result.email_sent
              ? "Enviamos por e-mail o link \"Criar minha senha\". Se quiser, mande também pelo WhatsApp."
              : "Não foi possível enviar o e-mail — copie o link abaixo ou mande pelo WhatsApp."}
          </DialogDescription>
        </DialogHeader>
        {result.invite_link && <InviteActions result={result} shopName={shopName} />}
        <Button data-testid="welcome-close-btn" type="button" onClick={onClose} className="h-10 bg-green-brand hover:bg-green-brandDark font-bold uppercase">
          Fechar
        </Button>
      </DialogContent>
    </Dialog>
  );
}
